module.exports = __webpack_public_path__ + "img/007户健.7347ab31.jpg";